import React, { useState, useEffect } from 'react';
import { Table, Spin, Tooltip, Popconfirm, message, Button ,Typography} from 'antd';
import { BASE_URL, DateTimeFormat, TIMEZONE_MAP, currencyMap, localeMap } from '../Components/Constant';
import ApiService from '../Components/apiService';
import { EditOutlined, DeleteOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import CreateRecordDrawer from '../Record/CreateRecordDrawer';
import { Form } from 'antd'; // Import Form
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UserDrawer from './CreateUserDrawer';
import dayjs from 'dayjs';
import { convertDateToUserTimezone, generateUTCMidnightDate, generateUTCDate } from '../Components/Utility';
import Cookies from 'js-cookie';
import { DateFormat } from '../Components/Constant';
import { GridBodyCtrl } from 'ag-grid-community';



const { Title } = Typography;

const UserComponent = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [activeCurrency, setActiveCurrency] = useState([]);
  const [loading, setLoading] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [form] = Form.useForm(); // Initialize form
  const [fieldsData, setFieldsData] = useState([]);
  const security = useSelector((state) => state.data.items[0]);
  const [userRoles, setUserRoles] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [mapOfDateDateTimeFieldWithValue, setMapOfDateDateTimeFieldWithValue] = useState({});




  const fetchActiveCurrency = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_currencies/`,
        { "Content-Type": "application/json" },
        "GET"
      );

      const response = await apiService.makeCall();
      const data = response || [];

      setActiveCurrency(data?.filter((cur) => cur.active));
    } catch (error) {
      
    } finally {
    }
  }
  const fetchUsers = async () => {
    const apiServiceForLookup = new ApiService(
      `${BASE_URL}/fetch_records/User`,
      { 'Content-Type': 'application/json' },
      'GET'
    );

    try {
      setLoading(true);
      const response = await apiServiceForLookup.makeCall();
      setUsers(response?.records);
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to fetch users due to an unknown error';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const fetchRoles = async () => {
    try {

      const apiServiceForRoles = new ApiService(
        `${BASE_URL}/get_all_user_role`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const rolesData = await apiServiceForRoles.makeCall();
      setUserRoles(rolesData);

    }
    catch (error) {

    }
  }

  const fetchFields = async () => {
    const apiServiceForFields = new ApiService(
      `${BASE_URL}/mt_fields/object/User`, // Adjust the endpoint if needed
      { 'Content-Type': 'application/json' },
      'GET'
    );
    try {
      const response = await apiServiceForFields.makeCall();
      setFieldsData(response);
    } catch (error) {
      console.error('Error fetching fields:', error);
    } finally {
    }
  };

  useEffect(() => {
    fetchFields();
    fetchUsers();
    fetchRoles();
    fetchActiveCurrency();
  }, []);


  const handleEdit = (record) => {
    if (security?.object_settings?.["User"]?.object_setting?.edit === false) {
      message.error('You dont have permission to edit ');
      return;
    }

    
let updatedData;
    const updatedMap = {}; // Temporary object to store date values
    updatedData = { ...record };

    fieldsData?.forEach(field => {

      if (field?.type === 'percentage' && updatedData[field?.name]) {
        updatedData[field?.name] = updatedData[field?.name];
      }
      if (field?.type === 'date' && updatedData[field?.name]) {
        const converteddate = convertDateToUserTimezone(updatedData[field.name], DateFormat);
        updatedData[field?.name] = converteddate;
        updatedMap[field?.name] = converteddate;
      }
      if (field?.type === 'datetime' && updatedData[field?.name]) {
        const converteddate = convertDateToUserTimezone(updatedData[field.name], DateTimeFormat);
        updatedData[field?.name] = converteddate;
        updatedMap[field?.name] = converteddate
      }
      if (field?.type === 'lookup' && updatedData[field?.name]) {
        updatedData[field?.name] = updatedData[field?.name] || '';
      }
      if ((field?.type === 'formula' || field?.is_formula) && updatedData[field?.name]) {
        const value = updatedData[field?.name];
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const addressKeys = ['street', 'city', 'state', 'country', 'postal_code', 'pincode'];
          const addressParts = addressKeys.map(k => value[k]).filter(Boolean);
          if (addressParts.length > 0) {
            updatedData[field?.name] = addressParts.join(', ');
          } else {
            updatedData[field?.name] = JSON.stringify(value);
          }
        }
      }
    });
    setMapOfDateDateTimeFieldWithValue(updatedMap);
    form.setFieldsValue(updatedData);

    setSelectedUser(updatedData);    setDrawerVisible(true);
  };

  const handleCloseDrawer = () => {
    setDrawerVisible(false);
    setSelectedUser(null);
  };

  const handleFinish = async (values) => {

    setLoading(true);

    const bodyData = { ...values };
    for (const field of fieldsData) {
      if (bodyData.hasOwnProperty(field?.name)) {
        if (field?.type === 'lookup' || field?.name === 'CreatedBy' || field?.name === 'LastModifiedBy') {
          let lookupFieldName = field?.name;

          if (bodyData[field?.name]?._id) {
            bodyData[lookupFieldName] = bodyData[field?.name]._id;
          } else {
            bodyData[lookupFieldName] = bodyData[field?.name] || null;
          }
          // delete bodyData[field?.name];
        }

        else if (field?.type === 'percentage' && bodyData[field?.name]) {
          bodyData[field?.name] = bodyData[field?.name] / 100;
        }

        else if (field?.type === 'address' && bodyData[field?.name]) {
          bodyData[field?.name] = {
            street: bodyData[field?.name]['street'] || '',
            city: bodyData[field?.name]['city'] || '',
            state: bodyData[field?.name]['state'] || '',
            postal_code: bodyData[field?.name]['postal_code'] || '',
            country: bodyData[field?.name]['country'] || '',
          };
        }

        else if (field?.type === 'date') {
          if (mapOfDateDateTimeFieldWithValue[field?.name]) {
            const utcDate = generateUTCMidnightDate(mapOfDateDateTimeFieldWithValue[field?.name]);
            bodyData[field?.name] = utcDate; // <-- assign converted value
          } else {
            console.log(`Date field ${field?.name} missing in map`);
          }
        }

        else if (field?.type === 'datetime') {
          if (mapOfDateDateTimeFieldWithValue[field?.name]) {
            const utcDate = generateUTCDate(mapOfDateDateTimeFieldWithValue[field?.name]);
            bodyData[field?.name] = utcDate;
          } else {
            console.log(`DateTime field ${field?.name} missing in map`);
          }
        }
      }
    }

    try {
      if (values?.currency) {
        Cookies.set('userCurrency', values.currency, { expires: 7 });
      }

      if (selectedUser?._id) {

        const body = {
          object_name: "User",
          data: {
            _id: selectedUser._id,  // Include the ID of the selected user
            ...bodyData
          }
        };

        console.log('body for update',body);

        const apiService = new ApiService(
          `${BASE_URL}/insert_or_update_records`,  // Use the ID of the selected user
          { 'Content-Type': 'application/json' },
          'POST',
          body
        );
        const response = await apiService.makeCall();
        fetchUsers();
        message.success('Record updated successfully.');
      } else {
        // Create new record
        const body = bodyData;

        const apiService = new ApiService(
          `${BASE_URL}/register`,
          { 'Content-Type': 'application/json' },
          'POST',
          JSON.stringify({ user: body })
        );
        await apiService.makeCall();
        message.success('Record created successfully.');
      }
      fetchUsers();
      handleCloseDrawer();
    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save record due to an unknown error';
      message.error(errorMessage);
      console.error('Error saving record:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleClick = (record) => {

    let updatedData;
    const updatedMap = {}; // Temporary object to store date values
    updatedData = { ...record };

    fieldsData?.forEach(field => {

      if (field?.type === 'percentage' && updatedData[field?.name]) {
        updatedData[field?.name] = updatedData[field?.name];
      }
      if (field?.type === 'date' && updatedData[field?.name]) {
        const converteddate = convertDateToUserTimezone(updatedData[field.name], DateFormat);
        updatedData[field?.name] = converteddate;
        updatedMap[field?.name] = converteddate;
      }
      if (field?.type === 'datetime' && updatedData[field?.name]) {
        const converteddate = convertDateToUserTimezone(updatedData[field.name], DateTimeFormat);
        updatedData[field?.name] = converteddate;
        updatedMap[field?.name] = converteddate
      }
      if (field?.type === 'lookup' && updatedData[field?.name]) {
        updatedData[field?.name] = updatedData[field?.name] || '';
      }
      if ((field?.type === 'formula' || field?.is_formula) && updatedData[field?.name]) {
        const value = updatedData[field?.name];
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          const addressKeys = ['street', 'city', 'state', 'country', 'postal_code', 'pincode'];
          const addressParts = addressKeys.map(k => value[k]).filter(Boolean);
          if (addressParts.length > 0) {
            updatedData[field?.name] = addressParts.join(', ');
          } else {
            updatedData[field?.name] = JSON.stringify(value);
          }
        }
      }
    });
    setMapOfDateDateTimeFieldWithValue(updatedMap);
    console.log('updated data',updatedData);
    form.setFieldsValue(updatedData);

    setSelectedUser(updatedData);
    setDrawerVisible(true);

  }

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      sorter: (a, b) => a.Name.localeCompare(b.Name),
      render: (text, record) => (
        <a onClick={() => handleClick(record)}>{text}</a>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
      sorter: (a, b) => a.username.localeCompare(b.username),
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (isActive) => (isActive ? 'Active' : 'Deactivated'),
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      // width: 100,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (text) => (
        text && dayjs(text).isValid()
          ? convertDateToUserTimezone(text, DateTimeFormat)
          : ''
      ),

    },
    {
      title: 'Updated At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      // width: 100,
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      render: (text) => (
        text && dayjs(text).isValid()
          ? convertDateToUserTimezone(text, DateTimeFormat)
          : ''
      ),

    },
    {
      title: 'Action',
      key: 'operation',
      render: (_, record) => (
        <>
          <Tooltip title="Edit">
            <EditOutlined
              style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
        </>
      ),
    },
  ];


  return (
    <div>
      {drawerVisible ? (
        <Spin tip="Loading..." spinning={loading}>

          <UserDrawer
            visible={drawerVisible}
            activeCurrency={activeCurrency}
            onClose={handleCloseDrawer}
            onFinish={handleFinish}
            loading={loading}
            objectName="User"
            fieldsData={fieldsData}
            selectedRecord={selectedUser}
            userRoles={userRoles}
            TIMEZONE_MAP={TIMEZONE_MAP}
            currencyMap={currencyMap}
            form={form}
            localeMap={localeMap}
            users={users}
            setMapOfDateDateTimeFieldWithValue={setMapOfDateDateTimeFieldWithValue}
            mapOfDateDateTimeFieldWithValue={mapOfDateDateTimeFieldWithValue}
            setDrawerVisible={setDrawerVisible}
            setSelectedUser={setSelectedUser}
          />
        </Spin>
      ) : (
        <Spin tip="Loading..." spinning={loading}>
          <Table
            title={() => (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <Title level={4} >User List</Title>
                <Button
                  type="primary"
                  style={{ marginBottom: 5, marginRight: "5px" }}
                  onClick={() => {
                    if (security?.object_settings?.["User"]?.object_setting?.create === false) {
                      message.error("You don't have permission to create");
                      return;
                    }
                    form.resetFields();
                    setSelectedUser(null);
                    setDrawerVisible(true);
                  }}
                >
                  Create
                </Button>



              </div>
            )}
            dataSource={users}
            columns={columns}
            rowKey="id"
            scroll={{ x: 'max-content', y: 550 }}
            pagination={{
              pageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              onChange: (page, pageSize) => {
                setPageSize(pageSize);
              },
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
          />
        </Spin>
      )}
    </div>

  );
};

export default UserComponent;